<template lang="html">
  <div v-if="showNavigation" class="grid-container full fixed">
    <div class="grid-x" :class="{navHeaderTrans: (Ypos < breakpoint) && !isProductsSection, navHeaderSolid: (Ypos > breakpoint) || isProductsSection}">

      <div class=" small-6 medium-2 cell">
        <header-logo
          class="header-logo"
          :class="{headerLogoSmall: ((Ypos > breakpoint && windowWidth < 800) || (isProductsSection && windowWidth < 800))}"
          @clicked="navigate('/')"
        />
        {{path}}
      </div>

      <div class="medium-10 cell text-right" id="desktopNav">
        <ul v-if="!isCandidatesSection" :class="{topNavigationTrans: (Ypos < breakpoint) && !isProductsSection, topNavigationSolid: (Ypos > breakpoint) || isProductsSection}">
          <router-link tag="li" to="/" :class="{exactActiveClass: isProductsSection}">
           <div tabindex="2" class="sub-nav-trigger" @mouseover="subNavHover(true)" @mouseleave="subNavHover(false)" @keypress="subNavHover(!showProductsSubNav)">
            Products
             <div v-if="showProductsSubNav" class="sub-nav">
               <ul class="sub-nav-list">
                 <router-link tabindex="3" @keypress.native="navigate('/products/crs')" tag="li" to="/products/crs" class="subRouterLink">Contextual&nbsp;recruitment<br/>system (CRS)</router-link>
                 <router-link tabindex="3" @keypress.native="navigate('/products/candid-ats')" tag="li" to="/products/candid-ats" class="subRouterLink">Candid ATS</router-link>
                 <router-link tabindex="3" @keypress.native="navigate('/products/hemisphere')" tag="li" to="/products/hemisphere" class="subRouterLink">Hemisphere</router-link>
                 <router-link tabindex="3" @keypress.native="navigate('/products/vantage')" tag="li" to="/products/vantage" class="subRouterLink">Vantage</router-link>
                 <router-link tabindex="3" @keypress.native="navigate('/products/attraction-and-development')" tag="li" to="/products/attraction-and-development" class="subRouterLink">Attraction and development</router-link>
               </ul>
             </div>
           </div>
          </router-link>
          <router-link tabindex="4" @keypress.native="navigate('/research')" tag="li" to="/research" exact-active-class="exactActiveClass" class="routerLink">Research</router-link>
          <router-link tabindex="5" @keypress.native="navigate('/stories')" tag="li" to="/stories" exact-active-class="exactActiveClass" class="routerLink">Stories</router-link>
          <router-link tabindex="6" @keypress.native="navigate('/about')" tag="li" to="/about" exact-active-class="exactActiveClass" class="routerLink">About</router-link>
          <router-link tabindex="7" @keypress.native="navigate('/candidates')" tag="li" to="/candidates" exact-active-class="exactActiveClass" class="routerLink">Candidates</router-link>
        </ul>

        <ul v-if="isCandidatesSection" :class="{topNavigationTrans: (Ypos < breakpoint) && !isProductsSection, topNavigationSolid: (Ypos > breakpoint) || isProductsSection}">
          <router-link tabindex="4" @keypress.native="navigate('/candidates')"  tag="li" to="/candidates" exact-active-class="exactActiveClass">What we do</router-link>
          <router-link tabindex="5" @keypress.native="navigate('/candidates/stories')" tag="li" to="/candidates/stories" exact-active-class="exactActiveClass">Stories</router-link>
          <router-link tabindex="6" @keypress.native="navigate('/candidates/research')" tag="li" to="/candidates/research" exact-active-class="exactActiveClass">Research</router-link>
          <router-link tabindex="7" @keypress.native="navigate('/candidates/about')" tag="li" to="/candidates/about" exact-active-class="exactActiveClass">About</router-link>
          <li v-if="!isApplyPage" class="apply-li">
            <rare-apply-now-button
              :tabIndex="8"
              style="display: inline-block; padding-top: 9px; "
              :buttonText="'Apply now'"
              :active="'true'"
              :height="'40px'"
              @clicked="navigate('/candidates/apply-now')"/>
          </li>

        </ul>
      </div>
      <div class="small-6 cell text-right" id="mobileNav">
        <rare-hamburger-icon
          v-if="!navigationOpen"
          class="hamburgerIcon"
          @clicked="openNavigation" />
      </div>
      </div>
  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import RareHamburgerIconSmall from 'rare-patternlab/icons/navigation/RareHamburgerIconSmall';
import HeaderLogo from './HeaderLogo';

export default {
  props: {
    path: {
      type: String,
    },
    navigationOpen: {
      type: Boolean,
    },
    showNavigation: {
      type: Boolean,
    },
  },
  components: {
    'header-logo': HeaderLogo,
    'rare-apply-now-button': RareStandardButton,
    'rare-hamburger-icon': RareHamburgerIconSmall,
  },
  data() {
    return {
      Ypos: 0,
      breakpoint: 655,
      showProductsSubNav: false,
      windowWidthPX: 0,
    };
  },
  computed: {
    isCandidatesSection() {
      return this.$route.path.includes('candidates');
    },
    isApplyPage() {
      return this.$route.path.includes('apply');
    },
    isProductsSection() {
      return (this.$route.path.includes('products') && !this.$route.path.includes('attraction-and-development')) ||
        this.$route.name.includes('Root');
    },
    windowWidth() {
      return this.windowWidthPX;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.calcBreakpoint);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.calcBreakpoint);
  },
  mounted() {
    this.calcBreakpoint();
    this.windowWidthPX = window.innerWidth;
  },
  methods: {
    navigate(path) {
      this.$router.push(path);
    },
    subNavHover(value) {
      this.showProductsSubNav = value;
    },
    handleScroll() {
      this.Ypos = parseInt(window.pageYOffset, 10);
    },
    calcBreakpoint() {
      this.windowWidthPX = window.innerWidth;
      if (window.innerWidth > 640) {
        this.breakpoint = (window.innerWidth / 2) - 78;
      } else if (window.innerWidth < 640) {
        this.breakpoint = window.innerWidth - 62;
      }
    },
    openNavigation() {
      this.$emit('openNavigation');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .desktopNav {
    transition: background-color 0.5s;
  }

  .sub-nav-trigger {
    position: relative;
  }

  .sub-nav {
    position: absolute;
    background-color: #ffffff;
    width: 290px;
    border-top: 4px solid $brown-highlight;
    top: 84px;
  }

  .sub-nav-list {
    margin: 25px 20px 10px 30px;
  }

  .sub-nav-list li {
    width: 240px;
    height: auto !important;
    min-height: 30px !important;
    max-height: 70px !important;
    margin: 0 0 15px 0 !important;
    border-bottom: 4px solid transparent;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.2em !important;
    text-transform: uppercase !important;
    text-align: left !important;
    color: $main-text !important;
  }

  .sub-nav-list li:last-child {
    margin-bottom: 11px !important;
  }

  @media only screen and (max-width: 796px)  {
    #desktopNav {
      display: none;
    }
    #mobileNav {
      display: block;
    }
  }
  @media only screen and (min-width: 796px)  {
    #desktopNav {
      display: block;
    }
    #mobileNav {
      display: none;
    }
  }


  @media only screen and (max-width: 950px)  {
    .topNavigationSolid li, .topNavigationTrans li {
      margin-left: 20px !important;
    }
  }

  .hamburgerIcon {
    margin: 19px 24px 0 0;
    cursor: pointer;
  }

  /* HEADER CONDITIONAL CSS */
  .navHeaderSolid {
    background-color: #343C43;
    transition: background-color 1s;
    color: #ffffff;
    height: 88px;
  }

  .navHeaderTrans {
    background-color: transparent;
    transition: background-color 1s;
    color: #ffffff;
    height: 88px;
  }

  /* LOGO CONDITIONAL CSS */
  .headerLogoSmall {
    width: 61px !important;
    margin: 24px 0 0 24px;
  }

.header-logo {
    width: 122px;
    margin: 27px 0 0 36px;
    height: auto;
    cursor: pointer;
    transition: width 250ms;
  }

  .topNavigationTrans {
    display: inline-block;
    height: 88px;
    line-height: 88px;
    margin-right: 30px;
  }

  .topNavigationTrans li {
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    //padding-bottom: 30px;
    height: 84px;
    line-height: inherit;
    letter-spacing: 3px;
    margin-left: 60px;
    text-align: center;
    text-transform: uppercase;
  }


  .topNavigationSolid {
    display: inline-block;
    height: 88px;
    line-height: 88px;
    margin-right: 30px;
  }

  .topNavigationSolid li {
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    height: inherit;
    line-height: inherit;
    letter-spacing: 3px;
    margin-left: 60px;
    text-align: center;
    text-transform: uppercase;
  }

  .topNavigationSolid li:first-child, .topNavigationTrans li:first-child {
    margin-left: 0;
  }


  .topNavigationSolid li:last-child, .topNavigationTrans li:last-child {
    margin-left: 45px;
  }

   .exactActiveClass, .routerLink:hover {
    border-bottom: 4px solid $brown-highlight !important;
  }

   .subRouterLink:hover {
     color: $brown-highlight !important;
   }

  .topNavigationTrans li.router-link-active,
  .topNavigationSolid li.router-link-active {
    cursor: default;
  }

  .topNavigationSolid li.apply-li:hover, .topNavigationTrans li.apply-li:hover {
    border-bottom: none !important;
  }

  @media only screen and (max-width: 640px)  {
    .navHeaderSolid, .navHeaderTrans {
      height: 62px !important;
    }

    .headerLogoSmall {
      width: 100px !important;
      margin: 19px 0 0 19px !important;
    }

  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {

    .header-logo {
      margin: 0 0 0 24px !important;
    }

    .topNavigationTrans, .topNavigationSolid{
      //margin-top: -40px !important;
    }
  }

  .fixed {
    position: fixed;
    width: 100%;
    z-index: 9970;
  }

  .vertical-align-middle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue